import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from 'screens/style';
// import resetPassword from 'assets/icons/resetPassword.png';
import { styleSizes } from "constants/styleSizes";

export const ResetPasswordScreenContainer = styled(BasicSectionContainer)`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .innerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 414px;
    //margin-top: 120px;
    .dateHint {
      box-shadow: none;
      margin-top: 60px;
    }
    position: relative;
    @media (max-width: ${styleSizes.tabletBreakpoint}) {
      height: 300px;
    }
    @media (max-width: ${styleSizes.tabletBreakpoint}) {
      align-items: baseline;
      padding-top: 56px;
    }
    @media (max-width: 770px) {
      height: 200px;
      padding: 20px 0 0 0;
    }
  }



  .titleContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.forgotPasswordBackground};
    width: 100%;

    padding: 0 15px;
    position: relative;

    @media (max-width: ${styleSizes.tabletBreakpoint}) {
      height: 300px;
    }
    @media (max-width: 770px) {
      height: 200px;
    }


    .titleText {
      width: 100%;
      margin: 0 20px 0 0;

      .title {
        font-size: 48px;
        font-weight: bold;
        line-height: 72px;
        text-align: left;
        color: ${colors.white};
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          font-size: 32px;
          line-height: 48px;
        } 
        .highLight {
          color: ${colors.checkOutCompleteScreenHighlight};
        }
        @media (max-width: 770px) {


        } 
        @media (max-width: 590px) {
          font-size: 24px;
          line-height: 32px;
          width: 220px;
        } 
      }
    }


    .resetPasswordImage {
        position: absolute;
        right: 31px;
        bottom: 0;
        width: 489px;
        height: auto;    
        @media (max-width: 1232px) {
          width: 445px;
        }
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          width: 369px;
        }
        @media (max-width: 770px) {
        width: 242px;
        right: 0;
        }
        @media (max-width: 450px) {
        width: 200px;
        right: -15px;
        }
      }
  }

  .inputRow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 15px;
      .innerContainerPass {
        height: auto;!important
      }
    .innerContainer {
      display: flex;
      flex-direction: column;
      width: 340px;
      min-width: 340px;
      padding: 44px 0;

      .titleText {
        font-size: 24px;
        font-weight: bold;
        color: ${colors.black};
        margin-bottom: 32px;
      }

      .buttonContainer {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: center;
        justify-self: center;
        align-self: center;

        svg {
          position: absolute;
          top: -85px;
          left: 100px;
        }
      }
    }
  }

  /* @media only screen and (max-width: 1200px) {

    .innerContainer {
      flex-direction: column-reverse;
      padding: 0;
      margin: 0;
    }

    .titleContainer {
      height: auto;

      .titleText {
        margin: 20px 0;

        .title {
          text-align: center;
          font-size: 36px;
        }
      }

      .resetPasswordImage {
        max-width: 270px;
        min-width: 270px;
        height: 183px;
        margin-top: 20px;
      }
    }
  } */
`;